'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactI18next = require('react-i18next');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function footerSubpage(props) {
    var _useTranslation = (0, _reactI18next.useTranslation)('footer'),
        t = _useTranslation.t;

    var buildSubpage = t("subpages", { returnObjects: true }).map(function (obj, key) {
        return _react2.default.createElement(
            'a',
            {
                href: props.returnFullURL(obj.url),
                className: 'footerAdditionalLink foot-link',
                key: key,
                target: "_blank",
                onClick: function onClick(e) {
                    e.preventDefault();
                    props.onURLClick(obj.url, 'footerSubPage');
                }
            },
            obj.title
        );
    });

    return _react2.default.createElement(
        'div',
        { className: 'col-12 col-lg-7 mb-3 order-2 order-lg-1 px-0' },
        _react2.default.createElement(
            'div',
            { className: 'footerAdditionalLinkContainer links d-flex justify-content-start flex-wrap pr-0' },
            buildSubpage
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
            'div',
            null,
            t("copyright", { returnObjects: true }).replace('[year]', new Date().getFullYear())
        )
    );
}

exports.default = footerSubpage;